import { ModalConfirmationTextures } from '@components/GenericModals/ModalConfirmationTextures'
import { useObjectContext } from '@context/ItemZoneContext'
import { useAppStore } from '@store'
import { Store } from '@types'
import { useState } from 'react'

export function BoxButtonsEditorWrapper() {
  const {
    currentTexture,
    actions: { handlePasteAll },
  } = useObjectContext()

  const applyToAllItems = useAppStore((s) => s.applyToAllItems)
  const id = useAppStore((s) => s.currentObjectID)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState({
    text: '',
    onConfirm: () => {},
  })
  const textos = useAppStore.use.textos()
  function t(str: string) {
    if (!textos.textos) return str
    if (!(str in textos.textos)) return str
    const str2 = str as unknown as keyof Store['textos']['textos']
    return textos.textos[str2]
  }
  const objectName = useAppStore(
    (s) =>
      s.items.get(s.currentObjectID)?.description ?? s.items.get(s.currentObjectID)?.description,
  )

  function openModalWithContent(text, onConfirm) {
    setModalContent({ text, onConfirm })
    setIsModalOpen(true)
  }

  function handleConfirmTextures() {
    return handlePasteAll()
  }

  function handleApplyToAllItems() {
    const originalID = id
    applyToAllItems(originalID)
  }

  return (
    <div className='mb-2 mt-auto flex content-end '>
      <div className='w-[327px] rounded-lg bg-C/Color10 p-2 shadow-md'>
        <button
          className='w-[313px] cursor-pointer rounded-md border border-solid border-C/Color7 bg-C/Color3 py-0.5 text-xs text-C/Color1'
          onClick={() =>
            openModalWithContent(
              `${'¿Quieres copiar el acabado'} ${t(currentTexture?.id)} ${'de la zona'} ${t(
                currentTexture.zoneDisplayName,
              )} ${'al resto de las zonas de la unidad'} ${t(objectName)}?`,
              handleConfirmTextures,
            )
          }
        >
          {'Copiar acabados a todas las zonas'}
        </button>
        <button
          className='w-[313px] cursor-pointer rounded-md border border-solid border-C/Color7 bg-C/Color3 py-0.5 text-xs text-C/Color1'
          onClick={() =>
            openModalWithContent(
              `${'¿Quiere copiar los acabados de todas las zonas de la unidad'} ${t(objectName)}, ${'en todas las zonas con el mismo nombre de todas las unidades del diseño?'}`,
              handleApplyToAllItems,
            )
          }
        >
          {'Copiar acabados a todas las piezas del proyecto'}
        </button>
      </div>
      {isModalOpen && (
        <ModalConfirmationTextures
          text={modalContent.text}
          onConfirm={modalContent.onConfirm}
          closeModal={() => setIsModalOpen(false)}
        />
      )}
    </div>
  )
}
